export const strings = {
  authTokenHeader: "Authorization",
  filtersTitle: {
    opened: "Esconder filtros",
    closed: "Mostrar filtros"
  },
  adoptableProps: {
    temper: {
      calm: "Tranquilo",
      active: "Activo",
      aggressive: "Agresivo"
    },
    size: {
      small: "Pequeño",
      medium: "Mediano",
      large: "Grande",
      xlarge: "Gigante"
    },
    kind: {
      dog: "Perro",
      cat: "Gato"
    },
    sex: {
      male: "Macho",
      female: "Hembra"
    },
    color: {
      beige: "Beige",
      white: "Blanco",
      brown: "Café",
      grey: "Gris",
      black: "Negro"
    }
  },
  formMessages: {
    imageLifecycle: [
      "Elegir foto",
      "Cargando...",
      "Cambiar foto"
    ],
    validation: {
      allFieldsRequired: "Todos los campos son requeridos",
      invalidAge: "Edad inválida",
      invalidEmail: "Correo electrónico inválido",
      invalidPhoneNumber: "Teléfono inválido",
      missingPicture: "Falta agregar foto",
      submitError: "No se pudo registrar",
      wrongCredentials: "Usuario o contraseña inválidos"
    }
  },
  genericMessages: {
    success: {},
    warning: {
      noMatchingAdoptables: "Lo sentimos, no se encontró ningún adoptable.",
      noAdoptionRequestsFound: "No hay solicitudes aún"    
    },
    error: {
      sessionExpired: "Tu sesión ha expirado",
      serverError: "Hay un problema con el servicio, prueba más tarde.",
      connectionError: "Hay problemas de conexión ¿Tienes acceso a internet?"
    },
  },
  locations: {
    aguascalientes: "Aguascalientes",
    baja_california: "Baja California",
    baja_california_sur: "Baja California Sur",
    campeche: "Campeche",
    chiapas: "Chiapas",
    chihuahua: "Chihuahua",
    cdmx: "Ciudad de México",
    coahuila: "Coahuila",
    colima: "Colima",
    durango: "Durango",
    estado_de_mexico: "Estado de México",
    guanajuato: "Guanajuato",
    guerrero: "Guerrero",
    hidalgo: "Hidalgo",
    jalisco: "Jalisco",
    michoacan: "Michoacán",
    morelos: "Morelos",
    nayarit: "Nayarit",
    nuevo_leon: "Nuevo León",
    oaxaca: "Oaxaca",
    puebla: "Puebla",
    queretaro: "Querétaro",
    quintana_roo: "Quintana Roo",
    san_luis_potosi: "San Luis Potosí",
    sinaloa: "Sinaloa",
    sonora: "Sonora",
    tabasco: "Tabasco",
    tamaulipas: "Tamaulipas",
    tlaxcala: "Tlaxcala",
    veracruz: "Veracruz",
    yucatan: "Yucatán",
    zacatecas: "Zacatecas",
    other: "Fuera de México",
  }
};

export const regex = {
  safePassword: /^[a-zA-Z0-9\.!@#$&*=?¿¡]{8,}$/,
  phoneNumber: /^([0-9]{10})$/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

export const urls = {
  api: {
    adminLogin: "https://us-central1-adopciones-norte.cloudfunctions.net/admin_login",
    deleteAdoptable: "https://us-central1-adopciones-norte.cloudfunctions.net/delete_adoptable",
    deleteAdoptionRequest: "https://us-central1-adopciones-norte.cloudfunctions.net/delete_adoption_request",
    getAdoptableInfo: "https://us-central1-adopciones-norte.cloudfunctions.net/get_adoptable_info",
    getAdoptables: "https://us-central1-adopciones-norte.cloudfunctions.net/get_adoptables",
    getAdoptionRequests: "https://us-central1-adopciones-norte.cloudfunctions.net/get_adoption_requests",
    updateAdoptable: "https://us-central1-adopciones-norte.cloudfunctions.net/update_adoptable",
    updateAdoptionRequest: "https://us-central1-adopciones-norte.cloudfunctions.net/update_adoption_request",
    uploadAdoptionRequest: "https://us-central1-adopciones-norte.cloudfunctions.net/register_adoption_request",
    registerAdoptable: "https://us-central1-adopciones-norte.cloudfunctions.net/register_adoptable"
  }
};